import { render } from "./attendanceReport.vue?vue&type=template&id=732c8bd7&ts=true"
import script from "./attendanceReport.vue?vue&type=script&lang=ts"
export * from "./attendanceReport.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__